import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { useObservable } from '@cdn/state';
import type { I18n } from './i18n';

const Context = createContext<I18n | undefined>(undefined);

/**
 * Provides localization to the tree and keeps the document language in step with the selection.
 */
export function I18nProvider({ i18n, children }: { i18n: I18n; children: ReactNode }) {
	const { locale } = useObservable(i18n);
	useEffect(() => {
		document.documentElement.lang = locale.code;
	}, [locale.code]);
	return <Context.Provider value={i18n}>{children}</Context.Provider>;
}

export function useI18n(): I18n {
	const i18n = useContext(Context);
	if (!i18n) throw new Error('useI18n needs an I18nProvider');
	return useObservable(i18n);
}
